import type { WafCheckContract } from '@terra/shared-contracts-waf-check';
import { wafCheckClient } from '@terra/shared-rest-clients-waf-check';
import { tenantAwareApiWrapper, withOrchestratorClient } from './api-core';

export const wafCheckApi = {
  checkUrl: ({ url }: { url: string }) =>
    tenantAwareApiWrapper<typeof WafCheckContract.check>({
      endpointFn: (headers) =>
        wafCheckClient.check({
          query: { url },
          ...withOrchestratorClient(headers),
        }),
    }),
};
